// actions
import * as actions from './actions';

// Define the initial state
const initialState = {
  // { prices: [...], oxxo: [...], currencies: [...] } from /shop/get_memberships/
  data: null,
  errorMemberships: null,
  loadingMemberships: false,
  loadingCheckout: false,
  initialMemberships: false,
  checkoutUrl: null,
};

// Define the reducer function
export default function membershipsReducer(state = initialState, action) {
  switch (action.type) {
    // FETCH
    case actions.FETCH_MEMBERSHIPS.REQUEST:
      return { ...state, loadingMemberships: true, errorMemberships: null };

    case actions.FETCH_MEMBERSHIPS.SUCCESS:
      return { ...state, loadingMemberships: false, initialMemberships: true, data: action.payload };

    case actions.FETCH_MEMBERSHIPS.FAILURE:
      return { ...state, loadingMemberships: false, initialMemberships: false, errorMemberships: action.payload };

    // CHECKOUT
    case actions.CHECKOUT_MEMBERSHIP.REQUEST:
      return { ...state, loadingCheckout: true, checkoutUrl: null, errorMemberships: null, };

    case actions.CHECKOUT_MEMBERSHIP.SUCCESS:
      // Keep loadingCheckout: true because we're about to redirect to Stripe
      // Setting it to false would briefly re-enable the button before redirect
      return { ...state, loadingCheckout: true, checkoutUrl: action.payload.urlStripe, errorMemberships: null };

    case actions.CHECKOUT_MEMBERSHIP.FAILURE:
      return { ...state, loadingCheckout: false, checkoutUrl: null, errorMemberships: action.payload, };

    default:
      return state;
  }
}
